/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowActionDetails {
    getFixupPrototypeFunction() { return WorkFlowActionDetails.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowActionDetails>): WorkFlowActionDetails {
        let obj = Object.assign(new WorkFlowActionDetails(), model);
        WorkFlowActionDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowActionDetails>): WorkFlowActionDetails {
        if (!model) return null;
        return WorkFlowActionDetails.newInstance(<WorkFlowActionDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowActionDetails) {
        if (!obj) return;

        models.WorkFlowActionDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowActionDetails): boolean {
        Object.setPrototypeOf(obj, WorkFlowActionDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Source of the Action to be taken.
     */
    action_source: models.WorkFlowSource;

    /**
     * Type of the Action based on source selected.
     */
    action_type: models.WorkFlowActionsType;

    /**
     * Key represents whether the approval is required or not.
     */
    approval_required: boolean = true;

    /**
     * Identifier of the tool account.
     */
    applicable_service_account: string;

}
